import { useService } from 'Hooks';
import React, { FunctionComponent, useEffect } from 'react';
import { AzureAdAuthenticationService } from 'Services/AzureAdAuthenticationService';

/**
 * SignInCallback
 * Azure AD will redirect here once the "sign-in" flow is finished
 */
const SignInCallback: FunctionComponent = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const azureAdAuthenticationService = useService(AzureAdAuthenticationService);

    useEffect(() => {
        const signInCallback = async () => {
            // Check if success or error.
            const error = urlParams.get('error');
            const errorDescription = urlParams.get('error_description');

            if (!error) {
                // Sign-in successful, now we try to obtain a token.
                await azureAdAuthenticationService.handleAuthorizeCallback();
            } else {
                // User clicked on "forgot password" on the sign-in page
                if (error === 'access_denied' && errorDescription?.startsWith('AADB2C90118')) {
                    await azureAdAuthenticationService.runResetPasswordFlow();
                }

                // Other error, show error page?
            }
        };

        signInCallback();
    }, []);

    return <div className="SignInCallback"></div>;
};

export default SignInCallback;
